import { NgModule } from '@angular/core';
import { DevkitComponent } from './devkit.component';

@NgModule({
  declarations: [DevkitComponent],
  imports: [
  ],
  exports: [DevkitComponent]
})
export class DevkitModule { }
